import {
  HeadlessDeliveryDocs,
  HeadlessDeliveryMachine,
} from './HeadlessDeliveryMachine';
import { GenericTypes } from '_core/domain/Utils/Generic/Types';

const onHeadlessDelivery: GenericTypes = {
  machine: HeadlessDeliveryMachine,
  docs: HeadlessDeliveryDocs,
  order: 1,
};

export default { onHeadlessDelivery };
